import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import {
  StationFilterContext,
  SITE_CLASS_VS30_CATALOGS,
} from "../../contexts/StationFilterContext";
import { StationCodeSelector } from "./StationCodeSelector";

export const StationSelectorForm2 = () => {
  const { state, dispatch } = useContext(StationFilterContext);
  const { t } = useTranslation();

  const handleInputValueChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, value } = event.target;
      const [category, key] = name.split(/\.(.+)/);
      if (category && key) {
        dispatch({
          type: "SET_FILTER_VALUE",
          category,
          key,
          value,
        });
      }
    }
  };

  const handleCheckedStateChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, checked: value } = event.target;
      const [category, key] = name.split(/\.(.+)/);
      if (category && key) {
        dispatch({
          type: "SET_FILTER_VALUE",
          category,
          key,
          value,
        });
      }
    }
  };

  const handleSelectorTypeChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, checked } = event.target;
      const [_, selectorType] = name.split(/\.(.+)/);
      dispatch({
        type: "SET_SELECTOR_TYPE",
        value: checked ? selectorType : "",
      });
    }
  };

  const handleLocationFilterTypeChanged = (event) => {
    const { checked, value } = event.target;
    dispatch({
      type: "SET_FILTER_VALUE",
      category: "location",
      key: "type",
      value: checked ? value : "",
    });
  };

  return (
    <div className="multiinput_container">
      <label
        className="datatable_select_radio"
        htmlFor="stationFilter.selectorType.byCondition"
      >
        <input
          type="checkbox"
          id="stationFilter.selectorType.byCondition"
          name="selectorType.byCondition"
          className="filled-in"
          checked={state.selectorType === "byCondition"}
          onChange={handleSelectorTypeChanged}
        />
        <span>{t("form.selectByFeatures")}</span>
      </label>
      {state.selectorType === "byCondition" && (
        <div style={{ marginLeft: "15px" }}>
          <div className="left multiinput_container">
            <span>{t("w.location")}: &nbsp;</span>
            <br className="show-on-medium-and-down hide-on-med-and-up" />
            <div className="inline-block">
              <label className="datatable_select_radio">
                <input
                  type="checkbox"
                  name="location.type"
                  className="filled-in"
                  value="boxRange"
                  checked={state.location.type === "boxRange"}
                  aria-label="관측소 위경도 범위 지정"
                  onChange={handleLocationFilterTypeChanged}
                />
                <span>
                  {t("w.latitude")}
                  <span className="hide-on-med-and-down">
                    &nbsp;{t("w.range")}
                  </span>
                </span>
              </label>
              <input
                type="text"
                name="location.minLat"
                placeholder="35.0"
                className="multiinput"
                aria-label="관측소 최소 위도"
                onBlur={handleInputValueChanged}
              />
              &nbsp; ~ &nbsp;
              <input
                type="text"
                name="location.maxLat"
                placeholder="38.0"
                className="multiinput"
                aria-label="관측소 최대 위도"
                onBlur={handleInputValueChanged}
              />
            </div>
          </div>
          <div className="left multiinput_container">
            <label className="datatable_select_radio">
              <input
                type="checkbox"
                name="location.type"
                className="filled-in"
                style={{ cursor: "default" }}
                tabIndex="-1"
                disabled
              />
              <span className="be_disabled" style={{ cursor: "default" }}>
                {t("w.longitude")}
                <span className="hide-on-med-and-down">
                  &nbsp;{t("w.range")}
                </span>
              </span>
            </label>
            <input
              type="text"
              name="location.minLon"
              placeholder="126.0"
              className="multiinput"
              aria-label="관측소 최소 경도"
              onBlur={handleInputValueChanged}
            />
            &nbsp; ~ &nbsp;
            <input
              type="text"
              name="location.maxLon"
              placeholder="129.0"
              className="multiinput"
              aria-label="관측소 최대 경도"
              onBlur={handleInputValueChanged}
            />
          </div>
          <div className="clearfix"></div>
          <div className="left multiinput_container">
            <span className="v-hidden hide-on-med-and-down ">
              {t("w.location")}: &nbsp;<span></span>
            </span>
            <label className="datatable_select_radio">
              <input
                type="checkbox"
                name="location.type"
                className="filled-in"
                value="circleRange"
                checked={state.location.type === "circleRange"}
                aria-label="관측소 위경도 중심 및 범위 지정"
                onChange={handleLocationFilterTypeChanged}
              />
              <span>
                <span className="hide-on-med-and-down">
                  {t("form.location.latitudeAndLongitude")}{" "}
                </span>
                {t("form.location.center")}
              </span>
            </label>
            <input
              type="text"
              name="location.centralLat"
              placeholder="36.3"
              className="multiinput"
              aria-label="관측소 중심 위도"
              onBlur={handleInputValueChanged}
            />
            , &nbsp;
            <input
              type="text"
              name="location.centralLon"
              placeholder="127.5"
              className="multiinput"
              aria-label="관측소 중심 경도"
              onBlur={handleInputValueChanged}
            />
          </div>
          <div className="left multiinput_container">
            <label className="datatable_select_radio">
              <input
                type="checkbox"
                name="location.type"
                className="filled-in"
                style={{ cursor: "default" }}
                tabIndex="-1"
                disabled
              />
              <span className="be_disabled" style={{ cursor: "default" }}>
                {t("form.location.radius")}
              </span>
            </label>
            <input
              type="text"
              name="location.maxRadius"
              placeholder="30"
              className="multiinput"
              aria-label="관측소 반경"
              onBlur={handleInputValueChanged}
            />
            km
          </div>
          <div className="mobile_blank"></div>
          <div className="clearfix"></div>
          <div className="col l12 s12">
            <div className="left multiinput_container">
              <span>{t("w.site_class")}: &nbsp;</span>
              <br className="show-on-medium-and-down hide-on-med-and-up" />
              <div className="inline-block">
                <label className="datatable_select_radio">
                  <input
                    type="checkbox"
                    name="siteClassVs30.enabled"
                    className="filled-in"
                    checked={state.siteClassVs30.enabled}
                    aria-label="VS30 기반 지반 분류 선택"
                    onChange={handleCheckedStateChanged}
                  />
                  <span>VS30 기반</span>
                </label>
              </div>
              {SITE_CLASS_VS30_CATALOGS.map((vs30) => (
                <div className="inline-block" key={vs30}>
                  <label className="datatable_select_radio">
                    <input
                      type="checkbox"
                      name={`siteClassVs30.${vs30}`}
                      className="filled-in"
                      disabled={!state.siteClassVs30.enabled}
                      checked={state.siteClassVs30[vs30]}
                      aria-label={vs30}
                      onChange={handleCheckedStateChanged}
                    />
                    <span>{vs30}</span>
                  </label>
                  &nbsp;&nbsp;
                </div>
              ))}
            </div>
          </div>
          {/* <div className="col l12 s12">
            <span>유형 : &nbsp;</span>
            <label className="datatable_select_radio" htmlFor="stationFilter.stationTypeSelector.hasSensorOnGround">
              <input type="checkbox" id="stationFilter.stationTypeSelector.hasSensorOnGround"
                name="stationTypeSelector.hasSensorOnGround" 
                className="filled-in"  
                onChange={handleCheckedStateChanged}
              />
              <span>지표형</span>
            </label>
            <label className="datatable_select_radio" htmlFor="stationFilter.stationTypeSelector.hasSensorInBorehole">
              <input type="checkbox" id="stationFilter.stationTypeSelector.hasSensorInBorehole"
                name="stationTypeSelector.hasSensorInBorehole"
                className="filled-in"  
                onChange={handleCheckedStateChanged}
              />
              <span>시추형</span>
            </label>
            <label className="datatable_select_radio" htmlFor="stationFilter.stationTypeSelector.hasSensorOnGroundAndInBorehole">
              <input type="checkbox" id="stationFilter.stationTypeSelector.hasSensorOnGroundAndInBorehole"
                name="stationTypeSelector.hasSensorOnGroundAndInBorehole"
                className="filled-in"  
                onChange={handleCheckedStateChanged}
              />
              <span>지표형 + 시추형</span>
            </label>
          </div>
          <div className="mobile_blank"></div> */}
        </div>
      )}
      <div className="clearfix"></div>
      <label
        className="datatable_select_radio"
        htmlFor="stationFilter.selectorType.byCode"
      >
        <input
          type="checkbox"
          id="stationFilter.selectorType.byCode"
          name="selectorType.byCode"
          className="filled-in"
          checked={state.selectorType === "byCode"}
          onChange={handleSelectorTypeChanged}
        />
        <span>{t("form.selectionDirectly")}</span>
        &nbsp;
      </label>
      <br className="hide-on-med-and-up" />
      {state.selectorType === "byCode" && <StationCodeSelector />}
    </div>
  );
};
